export const SUPPORT_ENDPOINTS = {
  SUPPORT: "/support",
} as const;
